import axios from 'axios'
import Cookies from 'js-cookie'
const url = process.env.REACT_APP_SERVER_URL;



export const addcustomer = async (data) => {
  const endpoint = `${url}/v1/escrow/customer`
  console.log("escrow endpoint reached...", data);
  const response = await axios({
    data,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': Cookies.get('token')
    },
    method: 'POST',
    timeout: 1000 * 60 * 10,
    url: endpoint,
  });
  return response;
}


export const offer = async ({_id,minimumOfferPrice,seller,userId,description,title,productcategory,buyNowPrice}) => {
    try{
    const referenceId = `LiveStock_${title}_${(Math.random() + 1).toString(36).substring(7)}`;
    const endpoint = `${url}/v1/escrow/offer`
    const response = await axios({
      data:{product_id:_id,referenceId:referenceId,minimumOfferPrice:minimumOfferPrice,seller:seller,userId:userId,description:description,title:title,productcategory:productcategory,buyNowPrice:buyNowPrice},
      headers: { 'Content-Type': 'application/json','Authorization': Cookies.get('token') },
      method: 'POST',
      timeout: 1000 * 60 * 10,
      url: endpoint,
    });
    console.log(response.data.data)
    return response.data.data;

  }
  catch(error)
  {
    console.log(error)
  }
  }


export const addbidusers=async ({productId,userId})=>{


  const endpoint = `${url}/v1/escrow/add-bid-user`
    const response = await axios({
      data:{userId:userId,productId:productId},
      headers: { 'Content-Type': 'application/json','Authorization': Cookies.get('token') },
      method: 'POST',
      timeout: 1000 * 60 * 10,
      url: endpoint,
    });
    console.log(response.data.data)
    return response.data.data;

}

